import React from "react";
import { useParams } from "react-router-dom";
import "../../assets/scss/components/_packagehero.scss";
import packages from "../../data/OurPackagesSection/packagesSection.json";

const PackageHero = () => {
  const { slug } = useParams();

  const packageData = packages.find((item) => item.slug === slug);

  if (!packageData) return null;

  return (
    <section className="package-hero">
      <img
        src={require(`../../assets/img${packageData.detailImage}`)}
        alt={packageData.title}
      />

      {/* <div className="package-hero__content">
        <h1>{packageData.title}</h1>
      </div> */}
    </section>
  );
};

export default PackageHero;

// import React from "react";
// import "../../assets/scss/components/_packagehero.scss";

// const PackageHero = ({ title, detailImage }) => {
//   return (
//     <section
//       className="package-hero"
//       style={{ backgroundImage: `url(${detailImage})` }}
//     >

//       <div className="package-hero__content">
//         <h1>{title}</h1>
//       </div>
//     </section>
//   );
// };

// export default PackageHero;
